import { Component, ElementRef, OnDestroy, OnInit } from "@angular/core";

import { ExternalConfigurationService } from "../../shared-library/services/configuration/external-configuration.service";
import { BrowserWindowService } from "../../shared-library/services/environment/browser-window.service";

import { BaseSearchTabConfigModel } from "./models/base-search-tab-config.model";
import { SearchPageConfigModel } from "./models/search-page-config.model";
import { SearchParametersFactoryService } from "./services/search-parameters-factory.service";

@Component({
    selector: AdvancedSearchComponent.SELECTOR,
    templateUrl: "./advanced-search.component.html"
})
export class AdvancedSearchComponent implements OnInit, OnDestroy {
    public static SELECTOR: string = "pcg-ng-advanced-search";
    protected activeSearchTab: string;
    protected searchPageConfig: Array<BaseSearchTabConfigModel>;

    public constructor(
        private _browserWindowService: BrowserWindowService,
        private _searchParametersFactory: SearchParametersFactoryService,
        private _configurationService: ExternalConfigurationService<SearchPageConfigModel>,
        private _domElement: ElementRef
    ) {
    }

    public ngOnInit(): void {
        this._configurationService.initialize(this._domElement);
        this.searchPageConfig = this._configurationService.config.searchPageConfig;

        const initialParameters = this._searchParametersFactory.createFromQueryString(this._browserWindowService.getQueryString());
        this.activeSearchTab = initialParameters.searchTab || this.searchPageConfig.find(x => x.isActive).tabAlias;
    }

    public ngOnDestroy(): void {
    }

    public switchSearchTab(tab: string): void {
        this.activeSearchTab = tab;
    }

    public getTabConfig(tabAlias: string): any {
        return this.searchPageConfig.find(config => config.tabAlias === tabAlias);
    }
}
